import { gql } from "@apollo/client";

export const CUSTOMER_LIST = gql`
  query CustomerLists {
    customersList(sort: { name: ASC }) {
      items {
        id
        phone
        email
        name
        state
        zip
        status
        address1
        address2
        city
        createdAt
        deletedAt
        sites {
          items {
            id
            name
          }
        }
      }
    }
  }
`;

export const CUSTOMER_LIST_SEARCH = gql`
  query CustomerListSearch($filter: CustomerFilter) {
    customersList(filter: $filter, sort: { name: ASC }) {
      items {
        id
        phone
        email
        name
        state
        zip
        status
        address1
        address2
        city
        createdAt
        deletedAt
        sites {
          items {
            id
            name
          }
        }
      }
    }
  }
`;

export const CUSTOMER_INFO = gql`
  query CustomerList($id: ID) {
    customersList(filter: { id: { equals: $id } }) {
      items {
        id
        phone
        email
        name
        state
        zip
        status
        address1
        address2
        city
        status
      }
    }
  }
`;
export const CUSTOMER_SITE_LIST = gql`
  query SitesList($id: ID!) {
    sitesList(filter: { customer: { id: { equals: $id } } }) {
      items {
        id
        name
        state
        zip
        address1
        address2
        city
        status
        radius
        geofenceType
        geolocation {
          coordinates
          type
        }
      }
    }
  }
`;
export const CUSTOMER_CREATE = gql`
  mutation CustomerCreate($data: CustomerCreateInput!) {
    customerCreate(data: $data) {
      id
    }
  }
`;
export const CUSTOMER_UPDATE = gql`
  mutation CustomerUpdate($data: CustomerUpdateInput!) {
    customerUpdate(data: $data) {
      id
    }
  }
`;

export const CUSTOMER_SITE_DETAILS = gql`
  query SitesList($id: ID!) {
    sitesList(filter: { id: { equals: $id } }) {
      items {
        id
        name
        state
        zip
        address1
        address2
        city
        status
        radius
        geofenceType
        isGeofence
        roundFrequencyMinutes
        isGeolocationMoved
        timeZone
        geolocation {
          coordinates
          type
        }
        origGeolocations {
          coordinates
        }
        geolocations {
          coordinates
        }
      }
    }
  }
`;
export const CUSTOMER_SITE_CREATE = gql`
  mutation SiteCreate($data: SiteCreateInput!) {
    siteCreate(data: $data) {
      id
      __typename
    }
  }
`;
export const CUSTOMER_SITE_UPDATE = gql`
  mutation SiteUpdate($data: SiteUpdateInput!) {
    siteUpdate(data: $data) {
      id
    }
  }
`;

// Comprehensive Site query with all fields including new geofence fields
export const SITE_COMPLETE_DETAILS = gql`
  query SiteCompleteDetails($id: ID!) {
    sitesList(filter: { id: { equals: $id } }) {
      items {
        id
        name
        state
        zip
        address1
        address2
        city
        status
        radius
        geofenceType
        roundFrequencyMinutes
        geolocation {
          coordinates
          type
        }
        customer {
          id
          name
          email
          phone
        }
        BannedEmployee {
          items {
            id
            employee {
              id
              name
              email
            }
          }
        }
        EmployeeRefused {
          items {
            id
            employee {
              id
              name
              email
            }
          }
        }
      }
    }
  }
`;

// Site query for geofence data only
export const SITE_GEOFENCE_DATA = gql`
  query SiteGeofenceData($id: ID!) {
    sitesList(filter: { id: { equals: $id } }) {
      items {
        id
        name
        radius
        geofenceType
        isGeofence
        isGeolocationMoved
        geolocations {
          coordinates
        }
        origGeolocations {
          coordinates
        }
        geolocation {
          coordinates
          type
        }
      }
    }
  }
`;

// Mutation to update site geofence data
export const UPDATE_SITE_GEOFENCE = gql`
  mutation UpdateSiteGeofence($data: SiteUpdateInput!) {
    siteUpdate(data: $data) {
      id
      radius
      geofenceType
      isGeofence
      geolocations {
        coordinates
      }
      geolocation {
        coordinates
        type
      }
    }
  }
`;

// Mutation to update isGeofence field specifically
export const UPDATE_SITE_IS_GEOFENCE = gql`
  mutation UpdateSiteIsGeofence($data: SiteUpdateInput!) {
    siteUpdate(data: $data) {
      id
      isGeofence
    }
  }
`;

export const SERVICES_LIST = gql`
  query ServicesList {
    servicesList(filter: { isActive: { equals: true } }) {
      items {
        service
        id
        isActive
        codes
      }
    }
  }
`;
export const CHECKPOINT_LIST = gql`
  query SiteCheckpointsList($id: ID!, $isActive: Boolean) {
    siteCheckpointsList(
      filter: { site: { id: { equals: $id } }, isActive: { equals: $isActive } }
    ) {
      items {
        id
        name
        qrCode
        isActive
        radius
        geolocation {
          coordinates
          type
        }
      }
    }
  }
`;

// Query to get all checkpoints for a site without filtering by isActive
export const ALL_CHECKPOINTS_LIST = gql`
  query AllSiteCheckpointsList($id: ID!) {
    siteCheckpointsList(
      filter: { site: { id: { equals: $id } } }
    ) {
      items {
        id
        name
        isActive
      }
    }
  }
`;

// Create Checkpoint Mutation (matches mobile)
export const CREATE_CHECKPOINT = gql`
  mutation CreateCheckpoint($data: SiteCheckpointCreateInput!) {
    siteCheckpointCreate(data: $data) {
      id
      name
      geolocation {
        type
        coordinates
      }
      radius
      qrCode
      isActive
      site {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;
export const ChECKPOINT_UPDATE = gql`
  mutation SiteCheckpointUpdate($data: SiteCheckpointUpdateInput!) {
    siteCheckpointUpdate(data: $data) {
      id
    }
  }
`;
export const SITE_LOGS = gql`
  query SiteLogsList($id: ID!) {
    siteLogsList(
      filter: {
        site: {
          id: { equals: $id }
          siteCheckpoint: { every: { site: { id: { equals: $id } } } }
        }
      }
      sort: { id: DESC }
    ) {
      items {
        id
        log
        entry
        employee {
          id
          user {
            id
            email
            firstName
            lastName
          }
        }
        round {
          items {
            id
            roundNumber
          }
        }
        siteCheckpoint {
          id
          name
        }
        site {
          id
          name
        }
      }
    }
  }
`;
